import {asCreator, withCallbacks} from '../../../../lib/utils';
import {compose} from '../../../../utils/functions';
import {actionTypes} from '../../reducers/notificationsReducer';

// Persists the admin's edits to the SEPARATE "Update contact info" home-address-correction
// draft (household did NOT move) — mirrors newAddressNotification.ts, which is Left Town ONLY.
export const updatedHomeAddressNotification = compose(
    withCallbacks,
    asCreator((data: any, id: number) => ({
        type: actionTypes.UPDATE_UPDATED_HOME_ADDRESS_NOTIFICATION,
        payload: data,
        id
    }))
);
